import React, { useEffect } from "react";
import "./VirasatV2ParkingPage.scss"
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
const VirasatV2ParkingPage = () => {

    const pages = useSelector((state) => state.companyData.pages)


    const page = pages.find((page) => page.PageId === "parking")

    const Components = page?.Components || []
    const history = useHistory()

    useEffect(() => {
        window.scrollTo(0, 0);
        if (Components.length === 0) {
            history.push("/")
        }
    }, []);
    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatParkingPage-hero-header":
                return <div className="VirasatV2ParkingPage-hero-header-cont">
                    <div className="VirasatV2ParkingPage-hero-header">{component?.Props?.header}</div>
                    <div className="VirasatV2ParkingPage-hero-subheader">{component?.Props?.subheader}</div>
                </div>
            default:
                return <div />
        }

    }
    const headerComponent = (headerComponents) => {
        return (
            <div className="VirasatV2ParkingPage-hero" style={{
                backgroundImage: `linear-gradient(0deg, rgba(22, 65, 106, 0.4), rgba(22, 65, 106, 0.4)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)),
linear-gradient(0deg, rgba(22, 65, 106, 0.2), rgba(22, 65, 106, 0.2)), url(${headerComponents?.Props?.bgSrc})`
            }}>
                <div className="VirasatV2ParkingPage-hero-container">
                    <div className="VirasatV2ParkingPage-hero-container-wrapper">
                        {sortByOrderAscending(headerComponents?.Components).map((component, key) => {
                            return (<div key={key}>
                                {getHeaderComponents(component)}
                            </div>)
                        })}
                    </div>
                </div>
            </div>
        )
    }
    const getcontentComponent = (component) => {
        switch (component.ID) {
            case "VirasatParkingPage-container-left-content-header":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-content-header">
                    {component?.Props?.text}
                </div>
            case "VirasatParkingPage-container-left-content-text":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-content-text">
                    {component?.Props?.text}
                </div>
            case "VirasatParkingPage-container-left-content-subheader":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-content-subheader">
                    {component?.Props?.text}
                </div>
            case "VirasatParkingPage-container-left-content-cont":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-content-cont">
                    {component?.Props?.text}
                </div>
            case "VirasatParkingPage-container-left-content-numbercont":
                return <>
                    <div className="VirasatV2ParkingPage-wrapper-container-left-content-number">
                        {component?.Props?.text}
                    </div>
                    <div className="VirasatV2ParkingPage-wrapper-container-left-content-cont">
                        {component?.Props?.list.map((val, key) => {
                            return (
                                <li key={key}>{val}</li>
                            )
                        })}
                    </div>
                </>
            case "VirasatParkingPage-container-left-content-subheader-margin50":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-content-subheader margin-top50">
                    {component?.Props?.text}
                </div>
            case "VirasatParkingPage-container-left-content-cont2":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-content-cont2">
                    <b>
                        {component?.Props?.boldText}
                    </b>
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }

    const contentComponent = (contentComponent) => {
        return (<div className="VirasatV2ParkingPage-wrapper-container-left-content">
            {sortByOrderAscending(contentComponent).map((component, key) => {
                return (
                    getcontentComponent(component)
                )
            })}
        </div>)
    }
    const getleftContComponents = (component) => {
        switch (component.ID) {
            case "VirasatParkingPage-container-left-title":
                return <div className="VirasatV2ParkingPage-wrapper-container-left-title">{component?.Props?.header}
                    <div className="VirasatV2ParkingPage-wrapper-container-left-title-hl">{component?.Props?.headerHighlight}</div>
                </div>
            case "VirasatParkingPage-container-left-content":
                return contentComponent(component?.Components)

            default:
                return <div />
        }

    }
    const leftContContainer = (leftcontainerComponents) => {
        return (
            <div className="VirasatV2ParkingPage-wrapper-container-left">
                {sortByOrderAscending(leftcontainerComponents).map((component, key) => {
                    return (
                        getleftContComponents(component)
                    )
                })}


            </div>
        )
    }
    const getContainerComponents = (component) => {
        switch (component.ID) {
            case "VirasatParkingPage-container-left":
                return leftContContainer(component?.Components)
            case "VirasatParkingPage-container-right":
                return <div className="VirasatV2ParkingPage-wrapper-container-right"
                    style={{ backgroundImage: `url(${component?.Props?.src})` }} />
            default:
                return <div />
        }

    }
    const containerComponent = (containerComponents) => {
        return (
            <div className="VirasatV2ParkingPage-wrapper">
                <div className="VirasatV2ParkingPage-wrapper-container">
                    {sortByOrderAscending(containerComponents).map((component, key) => {
                        return (
                            getContainerComponents(component)
                        )
                    })}
                </div >
            </div>

        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatParkingPage-hero":
                return headerComponent(component)
            case "VirasatParkingPage-container":
                return containerComponent(component?.Components)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatV2ParkingPage" >
            {sortByOrderAscending(Components).map((component, key) => {
                return (getComponents(component))
            })}

        </div >
    )
}
export default VirasatV2ParkingPage      